$(document).on('ready', () => {
  const $block = $('.video-with-text__media');

  if ($block.length === 0) return;

  const $btnPlay = $block.find('.btn-play');
  const $video = $block.find('video');

  $video.get(0).addEventListener('pause', () => {
    $block.removeClass('video-with-text__media--playing');
  });

  $btnPlay.on('click', () => {
    $block.addClass('video-with-text__media--playing');
    $video.get(0).play();
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/video-with-text.js